import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import AlertOrMacroMetadata from 'components/common/AlertOrMacroMetadata/AlertOrMacroMetadata';
import { TitleContainer, AlertTitle, AlertHeader } from 'components/tools/alerts/Alerts.styles';
import { parseSanitizedAlertContent } from 'util/alertUtil';
import { trackJITEscalationButtonClick } from 'analytics/buttonEventAnalytics';
import { isSelectedTicketTaken } from 'extractFromState';
import {
  Container,
  ContentContainer,
  IconWrapper,
  TypeIcon,
  Flex,
  EscalationMarker,
  Content,
  ButtonWrapper,
  EscalateButton,
} from './MWAlert.styles';

const DEFAULT_ALERT_CONTENT = 'Ticket out of scope. Please escalate';
const ESCALATION_ALERT_TEXT = '[ESCALATION ALERT]';

const propTypes = {
  // The `resource` prop should take an alert or macro object.
  resource: PropTypes.shape({
    content: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  onEscalateTicket: PropTypes.func.isRequired,
};

const MWAlert = ({ resource, resource: { content, title }, onEscalateTicket }) => {
  const ticketTaken = useSelector(isSelectedTicketTaken);
  const alertContent = content || DEFAULT_ALERT_CONTENT;

  const handleEscalateClick = () => {
    trackJITEscalationButtonClick();
    onEscalateTicket(title);
  };

  return (
    <Container>
      <AlertOrMacroMetadata resource={resource} />

      <ContentContainer>
        <IconWrapper>
          <TypeIcon src="/images/alert-icon-escalation.svg" alt="alert icon" />
        </IconWrapper>

        <Flex>
          <div>
            <AlertHeader>
              <TitleContainer>
                <AlertTitle>
                  <EscalationMarker>{ESCALATION_ALERT_TEXT}</EscalationMarker>
                  {title}
                </AlertTitle>
              </TitleContainer>
            </AlertHeader>
            <Content {...parseSanitizedAlertContent(alertContent)} />
          </div>

          {ticketTaken && (
            <ButtonWrapper>
              <EscalateButton onClick={handleEscalateClick}>Escalate</EscalateButton>
            </ButtonWrapper>
          )}
        </Flex>
      </ContentContainer>
    </Container>
  );
};

MWAlert.propTypes = propTypes;

export default MWAlert;
